// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3OZCO","selected":"Chip_selected__1RAlB"};